<template>
  <vue-final-modal
    v-slot="{ close }"
    :class="'modal-container ' + (dockPosition ? 'docked ' : '') + classDetail"
    content-class="modal-content "
    v-bind="$attrs"
    :esc-to-close="escToClose"
    :keep-overlay="keepOverlay"
    :drag="isDrag"
    :resize="resize"
    :content-style="styles"
    :click-to-close="false"
    drag-selector=".modal__title"
    class="ms-dynamic-popup"
    :transition="transition"
  >
    <div class="modal__title" :class="[{ modal__drag: isDrag }, classTitle]">
      <div class="title-left">
        <span class="title" @click="redirectClick">{{ title }}</span>
        <slot name="content-title" />
      </div>
      <div class="title-right">
        <slot name="icon" />

        <div
          v-if="maximumable"
          class="button icon24"
          :class="['button', maximum ? 'restore' : 'maximum']"
          @click="maximumClick"
        />
        <div
          v-if="showCloseIcon"
          v-tooltip="'Đóng (ESC)'"
          class="button icon20 ic_close-grey-16 close"
          @click="() => closeFunction(close)"
        />
      </div>
    </div>
    <div class="modal__content flex-column flex1">
      <span
        v-shortkey="defaultShortKey"
        class="popup-shortkey"
        @shortkey="shortkeyAction"
      />
      <slot name="content" :close="() => closeFunction(close)" />
    </div>
    <div v-if="$slots['footer']" class="modal__footer">
      <slot name="footer" :close="() => closeFunction(close)" />
    </div>
  </vue-final-modal>
</template>

<script>
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar';
export default {
  name: 'MsDynamicPopup',
  mixins: [shortkeyStatusbar],
};
</script>
<script setup>
import {
  defineProps,
  computed,
  getCurrentInstance,
  watchEffect,
  onMounted,
  onUnmounted,
  defineEmits,
  nextTick,
} from 'vue';
const { proxy } = getCurrentInstance();
const emit = defineEmits(['shortkeyAction', 'redirectClick']);
const props = defineProps({
  dragable: {
    type: Boolean,
    default: true,
  },
  resize: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: '',
  },
  maximum: {
    type: Boolean,
    default: false,
  },
  /**
   * Có hiển thị icon maxixum không
   */
  maximumable: {
    type: Boolean,
    default: false,
  },
  params: {
    type: Object,
    default: () => {},
  },
  classTitle: {
    type: String,
    default: '',
  },
  dockPosition: {
    type: String,
    default: null,
  },

  /**
   * Định nghĩa shortKey
   */
  shortkey: {
    default: null,
    type: [String, Object],
  },

  /**
   * class root
   */
  classDetail: {
    default: null,
    type: String,
  },

  /**
   * Truyền tên transition để áp dụng transition (transition đc định nghĩa trong file transitions.scss)
   * Có thể truyền theo object để bind lên
   */
  transition: {
    type: [Object, String],
    default: '',
  },
  /**
   * Có giữ overlay phía sau popup khi mở popup khác ko
   */
  keepOverlay: {
    type: Boolean,
    default: true,
  },
  /**
   * Có đóng khi nhấn esc ko
   */
  escToClose: {
    type: Boolean,
    default: true,
  },
  /**
   * Hàm xóa custom
   */
  customClose: {
    type: Function,
    default: null,
  },

  /**
   *Có autofocus vào input đầu tiên hay không?
   mặc định True;
   NTDIEM 20/04/2023
   */
  focusFistInput: {
    type: Boolean,
    default: true,
  },

/**
 * Thuộc tính có hiển thị icon đóng popup hay không
 * Mặc định: true(Có)
 * Ntdiem 26/06/2023
 */
  showCloseIcon: {
    type: Boolean,
    default: true,
  },
});
let defaultShortKey = Object.assign(
  {
    Close: ['esc'], //Đóng
    Save: ['ctrl', 's'], //Cất
    SaveAndAdd: ['ctrl', 'shift', 's'], //Cất và thêm
    Help: ['f1'], //Giúp
    Print: ['ctrl', 'p'], //IN
    Maximum: ['ctrl', 'space'], //phóng to thu nhỏ form
    QuickSelect: ['f3'], //chọn nhanh
    ArrowLeft: ['arrowleft'],
    ArrowRight: ['arrowright'],
    Postpone: ['ctrl', 'u'], //hoãn
    Edit: ['ctrl', 'e'], // sửa
    Refresh: ['ctrl', 'r'], //load lại grid
    Delete: ['ctrl', 'd'], //xóa
    Duplicate: ['ctrl', 'c'], //nhân bản
    Posted: ['ctrl', 'g'], //Ghi sổ
  },
  props.shortkey
);
let showPopup = true;
const isDrag = computed(() => {
  if (props.maximum) return false;

  if (props.dockPosition) return false;
  return props.dragable !== false;
});

const styles = computed(() => {
  const style = {};
  if (props.width) style.width = `${props.width}px`;

  if (props.height) style.height = `${props.height}px`;

  if (props.maximum) {
    style.width = '100%';
    style.height = '100vh';
    style.top = 0;
    style.left = 0;
  }

  if (props.dockPosition) {
    style.height = '100vh';
    switch (props.dockPosition) {
      case 'left':
        style.left = 0;
        break;
      case 'right':
        style.right = 0;
        break;
    }
  }
  return style;
});

/**
 * Push el để xử lý shortkey cho view
 */
onMounted(() => {
  proxy.$ms.commonFn.shortkeyPushView(proxy.$el);
  //Kiểm tra nếu mặc định focus vào ô input đầu tiên thì thực hiện gọi commonFn
  if (props.focusFistInput) {
    setTimeout(async () => {
      proxy.$ms.commonFn.focusFirstControlInput(proxy.$el);
    }, 100);
  }
});

/**
 * Loại bỏ el dùng cho shortkey
 */
onUnmounted(() => {
  proxy.$ms.commonFn.shortkeyPopView(proxy.$el);
});
/**
 * emit event click title
 * bnanh 01.07.2022
 */
const redirectClick = () => {
  emit('redirectClick');
};

const maximumClick = () => {
  proxy.$emit('update:maximum', !props.maximum);
};

/**
 * emit event phím tắt
 */
const shortkeyAction = (e) => {
  let me = this;
  switch (e.srcKey) {
    default:
      emit('shortkeyAction', e);
      break;
  }
};

/**
 * Hàm đóng popup
 * @param {function} closeBase hàm đóng của base
 * @author: BMThang(13/01/2022)
 */
const closeFunction = (closeBase) => {
  // Nếu có custom close thì gọi hàm này
  if (typeof props.customClose === 'function') {
    props.customClose(closeBase);
    return;
  }
  closeBase();
};

const updateModelValue = (value) => {};
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/function.scss';

:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  &.docked {
    justify-content: unset;
  }
}
:deep(.modal-content) {
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__content {
  flex: 1;
  padding: 24px;
}
.modal__title {
  padding: 24px 24px 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    cursor: move;
  }
  .title {
    font-size: $ms-popup__title-font-size;
    font-weight: $font-weight-bold;
    color: #202104;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    padding: 10px 8px;
  }

  .title-right {
    display: flex;
    align-items: center;
    .close {
      transition: background-color 0.2s ease;
      padding: 18px;
      border-radius: 50%;
      &:hover {
        background-color: var(--grey-20);
      }
    }
  }
}
.modal__footer {
  padding: 12px 24px;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid var(--grey-40);
  background-color: #f5f5f5;
  // @include for_breakpoint(desktop-xl) {
  //   height: $ms-popup__footer-height-xl;
  // }
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>
